import DOMPurify from "dompurify";
import "./components";
import { ConditionalFormHandling } from "../src/conditional_form_handling";
import FormBuilderV2 from "../src/form_builder_v2_helpers";
import { modifyEmailHtmlForPreview } from "../src/email_html_modifier";
import $ from "jquery";
import("../src/patches/jquery_patch");
import DataTable from "datatables.net";
window.DOMPurify = DOMPurify;
window.modifyEmailHtmlForPreview = modifyEmailHtmlForPreview;
window.ConditionalFormHandling = ConditionalFormHandling;
window.FormBuilderV2 = FormBuilderV2;
window.$ = $;
window.jQuery = $;
DataTable.defaults.column.orderSequence = ["asc", "desc"];
